// extracted by mini-css-extract-plugin
export default {"zoomModal":"V0-z","image":"W0-z","button":"X0-z","isOverlayShown":"Y0-z"};